import axios from 'axios';
import { AnyAction, combineReducers } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import config from 'config';
import { createAction } from 'ducks/actionHelpers';
import { CreateInquiryRequest } from 'models/inquiry';

// Actions
const CREATE_INQUIRY_REQUEST = 'CREATE_INQUIRY_REQUEST';
export const CREATE_INQUIRY_SUCCESS = 'CREATE_INQUIRY_SUCCESS';
const CREATE_INQUIRY_FAILURE = 'CREATE_INQUIRY_FAILURE';

// Action creators
const createInquiryRequest = (payload: CreateInquiryRequest) =>
  createAction(CREATE_INQUIRY_REQUEST, payload);
export const createInquirySuccess = (payload: CreateInquiryRequest) =>
  createAction(CREATE_INQUIRY_SUCCESS, payload);
const createInquiryFailure = (payload: string) => createAction(CREATE_INQUIRY_FAILURE, payload);

export const createInquiry = (apiKey: string, req: CreateInquiryRequest, language: string) => (
  dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, AnyAction>
): void => {
  dispatch(createInquiryRequest(req));
  axios
    .post(`${config.apiUrl}/inquiries`, req, {
      headers: {
        'x-api-key': apiKey,
        'accept-language': language,
      },
    })
    .then(() => {
      dispatch(createInquirySuccess(req));
    })
    .catch((err) => {
      dispatch(createInquiryFailure(err.message));
    });
};

type Action =
  | ReturnType<typeof createInquiryRequest>
  | ReturnType<typeof createInquirySuccess>
  | ReturnType<typeof createInquiryFailure>;

// Reducers
const error = (state = '', action: Action) => {
  switch (action.type) {
    case CREATE_INQUIRY_FAILURE:
      return action.payload;
    case CREATE_INQUIRY_REQUEST:
    case CREATE_INQUIRY_SUCCESS:
      return '';
    default:
      return state;
  }
};

const loading = (state = false, action: Action) => {
  switch (action.type) {
    case CREATE_INQUIRY_REQUEST:
      return true;
    case CREATE_INQUIRY_SUCCESS:
    case CREATE_INQUIRY_FAILURE:
      return false;
    default:
      return state;
  }
};

export interface CouponsState {
  error: ReturnType<typeof error>;
  loading: ReturnType<typeof loading>;
}

export default combineReducers({
  error,
  loading,
});
